<div class="autocomplete-container mt-6 relative rounded-t-md" [ngClass]="{
    'border-t-red-600 border-r-red-600 border-l-red-600 border':
      showError && !valor()
  }">
  <p-calendar #calendar
    [(ngModel)]="valor"
    (onBlur)="show = false"
    (onFocus)="show = true"
    (onShow)="show = true"
    appendTo="body"
    [style]="{ width: '100%' }"
    [showClear]="showClear"
    [showIcon]="true"
    iconDisplay="input"
    hourFormat="24"
    [showTime]="showTime"
    [timeOnly]="timeOnly"
    [showSeconds]="false"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [readonlyInput]="true"
    [locale]="locale"
    [dateFormat]="dateFormat"
    [defaultDate]="minDate ? minDate : today"
    [disabled]="readonly" />
  <label class="label absolute top-1/2 -translate-y-1/2 left-0 pointer-events-none"
    [ngClass]="{ 'label-active': show || valor() }">
    {{ etiqueta }}
  </label>
  <label class="place absolute pl-2 top-1/2 -translate-y-1/2 left-0 pointer-events-none" [ngClass]="{
      'opacity-100': show && !valor(),
      'opacity-0': !show || valor()
    }">
    {{ placeholder }}
  </label>
  <div class="underline" [ngClass]="{ 'underline-show': show, 'underline-hide': !show }"></div>
</div>

<div class="hide" [ngClass]="{ show: showError && !valor() }">
  <div>
    <small class="flex justify-start items-center text-red-600 mt-1">
      <svg width="10px" height="10px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
        class="mr-[2px]">
        <path d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5" stroke="#dc2626" stroke-width="2"
          stroke-linecap="round" />
        <path
          d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
          stroke="#dc2626" stroke-width="2" stroke-linecap="round" />
      </svg>
      {{ mensajeError }}
    </small>
  </div>
</div>